import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  GroupedNotificationsRequest,
  GroupedNotificationsResponse,
  NotificationCountResponse,
  NotificationsByTypeResponse
} from '../models/notifications-grouped.model';

@Injectable({ providedIn: 'root' })
export class NotificationsHubService {
  private readonly baseUrl = '/api/notifications';

  constructor(private http: HttpClient) {}

  getGroupedNotifications(request: GroupedNotificationsRequest): Observable<GroupedNotificationsResponse> {
    return this.http.post<GroupedNotificationsResponse>(`${this.baseUrl}/grouped-by-category`, request);
  }

  markAsRead(notificationId: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/read/${notificationId}`, null);
  }

  deleteNotification(notificationId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/delete/${notificationId}`);
  }

  getNotificationsByType(
    notificationTypeId: number,
    withinDays: number,
    pageNumber: number,
    pageSize: number
  ): Observable<NotificationsByTypeResponse> {
    return this.http.get<NotificationsByTypeResponse>(`${this.baseUrl}/by-notificationtype/${notificationTypeId}`, {
      params: { withinDays, pageNumber, pageSize }
    });
  }

  getNotificationCounts(request: GroupedNotificationsRequest): Observable<NotificationCountResponse> {
    return this.http.post<NotificationCountResponse>(`${this.baseUrl}/counts`, request);
  }

  downloadReport(sourceEntityId: string): Observable<Blob> {
    return this.http.get(`/api/reporting/status/${sourceEntityId}/download`, { responseType: 'blob' });
  }
}
